import React, {useState, useEffect, useRef} from 'react'
import { IoIosPersonAdd } from 'react-icons/io';
import { useAuth } from '../../../context/Auth';
import { useGlobalContext } from '../../../context/stateContext';
import { RotatingLines } from 'react-loader-spinner';

const BatchTracking = () => {
    const searchRef = useRef();
  const { requestWithAuth } = useAuth();
  const {activeSession} = useGlobalContext();
  const [loading, setLoading] = useState(false);
  const [loadingDrugs, setLoadingDrugs] = useState(false)
  const [drugsDropdown, setDrugsDropdown] = useState(true);
  const [drugs, setDrugs] = useState([]);
  const [selectedDrug, setSelectedDrug] = useState(null);
  const [search, setSearch] = useState("");

  const getDrugs = async (search_query) => {
    setLoadingDrugs(true);
    try {
      const data = await requestWithAuth(
        `/inventory/branch/${activeSession?.branch?.id}?page=1&pageSize=10000000000000&search=${search_query}`,
        "GET"
      );
      setDrugs(data?.results);
    } catch (error) {
      console.error("Error fetching users data:", error);
    } finally {
        setLoadingDrugs(false);
    }
  };

  const getBatchTracking = async () => {
    
    window.location.href = `/inventory/batch-tracking/print?branch=${activeSession?.branch?.id}&drug=${selectedDrug?.id}`
  };

  useEffect(() => {
    if (search.length > 2) {
      getDrugs(search);
    }
  }, [search]);

  return (
    <div className="px-[20px] pb-[200px]">
      <div className="py-[32px] flex items-center gap-3">
        <IoIosPersonAdd className="text-[19px]" />
        <h4 className="text-[19px]">
          <b>Inventory</b> - Batch Tracking
        </h4>
      </div>

      <div className="lg:w-[40%] mx-auto">
        <div className="">
          <div className="mb-[20px] border border-[#ddd] rounded-[3px] bg-white">
            <div className="p-[20px]">
              <h5 className="my-[2px] text-[17px]">
                Batch Tracking
              </h5>
            </div>
            <div className="p-[20px] pt-0">
              <div className="flex items-center gap-2 mb-[20px] pb-[10px] uppercase border-b border-[#e5e5e5]">
                <IoIosPersonAdd className="text-[12px]" />
                <label htmlFor="item" className="text-[12px] font-[500]">
                  Branch Details
                </label>
              </div>
            
              <div className="flex flex-col col-span-2 mb-[20px]">
                <label htmlFor="" className="font-bold">
                  Drug Name:
                </label>
                <div
                  className="relative cursor-pointer border h-[35px] border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                  onClick={() => {
                    setDrugsDropdown(!drugsDropdown);
                    searchRef.current.focus();
                  }}
                >
                  {selectedDrug?.name}
                  <div
                    onClick={(e) => e.stopPropagation()}
                    className={`absolute -bottom-[100px] w-full bg-white left-0 border border-[#ddd] ${
                      drugsDropdown ? "block" : "hidden"
                    }`}
                  >
                    <div className="p-2">
                      <input
                        ref={searchRef}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        type="text"
                        className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px] w-full"
                      />
                    </div>
                    <p className="p-2 text-gray-500">
                      {search?.length < 3 ? (
                        "Please enter at least 2 characters"
                      ) : (
                        <>
                          {loadingDrugs ? (
                            "Searching..."
                          ) : (
                            <>
                              {drugs?.length > 0 ? (
                                <div className="max-h-64 overflow-y-scroll absolute bg-white w-full left-0">
                                  {drugs?.map((drug_item) => {
                                    return (
                                      <div
                                        onClick={() => {setSelectedDrug(drug_item?.drug); setDrugsDropdown(false)}}
                                        className="p-2 hover:bg-red-500 hover:text-white"
                                      >
                                        {drug_item?.drug?.name} - Ghc{" "}
                                        {drug_item?.drug?.selling_price}
                                      </div>
                                    );
                                  })}
                                </div>
                              ) : (
                                "No result found"
                              )}
                            </>
                          )}
                        </>
                      )}
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex justify-end">
                {loading ? (
                  <div className="bg-[#2195f3d9] flex items-center gap-2 px-[12px] py-[7px] text-[13px] rounded-[3px] mt-5 text-white">
                    <RotatingLines
                      visible={true}
                      height="16"
                      width="16"
                      color="black"
                      strokeColor="white"
                      strokeWidth="5"
                      animationDuration="0.75"
                      ariaLabel="rotating-lines-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />{" "}
                    Submitting
                  </div>
                ) : (
                  <button    
                    onClick={()=>getBatchTracking()}                
                    className="bg-[#2196F3] px-[12px] py-[7px] text-[13px] rounded-[3px] mt-5 text-white"
                  >
                    Submit
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BatchTracking